<template>
  <div class="dialog-add-account__form-row">
    <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
      <div class="dialog-add-account__form-item">
        <div class="form-input" :class="[{ 'form-input--full': value && value !== 'not_receive' }]">
          <select :value="value" required :disabled="disabled" @change="handleChange">
            <option v-for="option in options" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
          <span class="form-input__label">
            {{ label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformTypeSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator: (options) => {
        return options.every((opt) => typeof opt === 'object' && 'value' in opt && 'label' in opt);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>
